import { bigQuery } from '@fiverr-private/obs';
import * as bq from './bigQueryEventTypes';

export interface BigQueryEventParams {
    eventName: string;
    params?: {
        sourcePageKey?: string;
        guideKey?: string;
        position?: number;
    };
}

export const getGuideKeyFromUrl = (url: string) => {
    const parts = url.split('/resources/guides/');
    if (parts.length < 2) return '';
    return parts.pop()?.split('/').join('_') || '';
};

export const sendBigQueryEvent = ({ eventName, params = {} }: BigQueryEventParams) => {
    let eventData: any = {
        group: 'user_action',
        type: 'clicked_on_related_guides',
        action: {
            type: 'click',
        },
        feature_name: 'related_guides',
    };

    const { sourcePageKey, guideKey, position } = params;

    switch (eventName) {
        case bq.BQ_CLICKED_RELATED_GUIDE:
            eventData = {
                ...eventData,
                page: {
                    name: sourcePageKey,
                    element: {
                        ...(position && { position }),
                        text: guideKey,
                    },
                    component: {
                        name: 'related_guides',
                    },
                },
            };
            break;

        case bq.BQ_CLICKED_SEE_MORE_GUIDES:
            eventData = {
                ...eventData,
                page: {
                    name: sourcePageKey,
                    element: {
                        text: 'see-more-link',
                    },
                    component: {
                        name: 'related_guides',
                    },
                },
            };
            break;

        default:
            break;
    }

    bigQuery.send(eventData);
};
